<template>
  <section>
    <div style="display: flex; width: 100%; gap: 10px; align-items: stretch">
      <select class="dark-slicky-select" style="flex: 1; min-width: 0" v-model="route.name" @change="parseActivity" v-if="!justIDMode">
        <option value="" disabled>escolher tipo</option>
        <option class="ap-option-item" :value="route" v-for="(route, r) in routes" :key="r">{{ `${route}` }}</option>
        <option class="ap-option-item" :value="''">Desabilitar</option>
      </select>
      <select class="dark-slicky-select" style="flex: 1; min-width: 0" v-model="routeStream" @change="parseStream" v-if="route.name != 'url' && route.name != 'Agenda'">
        <option value="" disabled>escolher atividade</option>
        <option class="ap-option-item" :value="activity.activity_id" v-for="activity in activities" :key="activity.activity_id" v-html="activity.activity"></option>
      </select>
      <select class="dark-slicky-select" style="flex: 1; min-width: 0" v-model="agendaStartDate" @change="parseStream" v-if="route.name == 'Agenda'">
        <option value="" disabled>escolher data</option>
        <option class="ap-option-item" :value="startDate" v-for="startDate in agendaDates" :key="startDate">{{ startDate }}</option>
      </select>
      <select class="dark-slicky-select" style="flex: 1; min-width: 0" v-model="standFromActivity" @change="standChanged" v-if="standsComputed.length">
        <option value="/">/</option>
        <option class="ap-option-item" :value="stand" v-for="stand in standsComputed" :key="stand" :title="stand">{{ stand }}</option>
      </select>
      <select class="dark-slicky-select" style="flex: 1; min-width: 0" v-model="explorerPanel" @change="parseActivity" v-if="explorerPanels.length">
        <option v-for="panel in explorerPanels" :key="panel" :value="panel">{{ panel }}</option>
      </select>
    </div>
    <Spinner :showSpinner="showSpinner" style="position: absolute; inset: 0; width: 100%; height: 100%; z-index: 1" />
  </section>
</template>

<script>
import api from '@/services/api.js';
import Spinner from '@/components/ui/Spinner.vue';

export default {
  name: 'ActivityPicker',

  components: {
    Spinner,
  },

  props: {
    routeName: String,
    stream: String,
    stand: String,
    justIDMode: Boolean,
  },

  data() {
    return {
      apiLimit: 100000,
      apiPage: 0,
      activities: [],
      routes: [],
      route: { name: '', params: { stream: '' } },
      routeStream: '',
      showStreamSelect: true,
      conformedRoute: '',
      standFromActivity: '',
      stands: [],
      showSpinner: false,
      agendaStartDate: '',
      agendaDates: [],
      explorerPanel: 'Map',
    };
  },

  computed: {
    standsComputed() {
      this.stands = [];
      this.activities
        .filter((act) => act.activity_type == 'Areas' && act.activity_id == this.routeStream)
        .map((item) => {
          item.property = JSON.parse(item.property);
          item.property.foyer2D.areas.map((area) => this.stands.push(area.title));
        });
      return this.stands;
    },
    explorerPanels() {
      // Only show for Explorer route
      if (this.route.name === 'Explorer') {
        return ['map', 'passport'];
      }
      return [];
    },
  },
  methods: {
    loadRoutes() {
      this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/activities?limit=${this.apiLimit}`)
        .then((response) => {
          // console.log('loadRoutes', { response });

          this.routes = response.data.map((route) => route.activity_type);
          this.routes = [...new Set(this.routes)];
          if (!this.routes.some((element) => element?.includes('Agenda'))) this.routes.push('Agenda');
          this.routes.push('url');

          if (this.routeName) {
            this.loadActivities(this.routeName);
            this.route.name = this.routeName;
          }
          this.showSpinner = false;
        })
        .catch((err) => {
          console.error(err);
          this.showSpinner = false;
        });
    },
    loadActivities(activityType) {
      api
        .get(`event/${this.$store.state.eventId}/activities?limit=${this.apiLimit}`)
        .then((response) => {
          if (!activityType) this.route.name = this.displayRoute(this.routeName);
          this.routeStream = this.stream;
          this.standFromActivity = this.stand;
          this.activities = response.data;
          if (activityType) {
            this.activities = response.data.filter((activity) => {
              return activity.activity_type == activityType;
            });
          }
          this.showSpinner = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    parseActivity() {
      if (this.route.name == '') {
        this.$emit('reset');
        this.routeStream = '';
        return;
      }
      this.loadActivities(this.route.name);
      let conformedRouteName = this.conformRouteName(this.route.name);
      if (!conformedRouteName) return;
      // Do NOT overwrite routeStream with a stringified object
      if (conformedRouteName == 'url') {
        this.$emit('routeSelected', 'https://');
        this.$emit('conformedRouteSelected', 'https://');
      } else {
        this.activities = this.activities.filter((activity) => activity.activity_type == this.route.name);
        if (this.route.name === 'Explorer') {
          // Only emit once for Explorer, with correct stream
          const explorerRoute = {
            name: conformedRouteName,
            params: { stream: this.routeStream, panel: this.explorerPanel },
          };
          this.$emit('routeSelected', JSON.stringify(explorerRoute));
          this.$emit('conformedRouteSelected', JSON.stringify(explorerRoute));
        } else if (this.route.name === 'Agenda') {
          const agendaRoute = { name: 'Schedule', params: { date_start: this.agendaStartDate } };
          this.$emit('routeSelected', JSON.stringify(agendaRoute));
          this.$emit('conformedRouteSelected', JSON.stringify(agendaRoute));
        } else {
          const genericRoute = { name: conformedRouteName, params: { stream: this.routeStream } };
          this.$emit('routeSelected', JSON.stringify(genericRoute));
          this.$emit('conformedRouteSelected', JSON.stringify(genericRoute));
        }
        this.conformedRoute = conformedRouteName;
        if (!conformedRouteName) this.$emit('streamPicked');
      }
    },
    conformRouteName(routeName) {
      switch (routeName) {
        case 'Agenda':
          return 'Schedule';
        case 'Trilhas':
          return 'Trails';
        case 'Perfil':
          return 'UserProfile';
        case 'Foyer 2D':
          if (this.route.name === 'Agenda') {
            this.$emit('conformedRouteSelected', JSON.stringify({ name: 'Schedule', params: { date_start: this.agendaStartDate } }));
          } else if (this.route.name === 'Explorer') {
            // Emit selected panel for Explorer
            this.$emit('conformedRouteSelected', JSON.stringify({ name: conformedRouteName, params: { stream: '', panel: this.explorerPanel } }));
          } else {
            this.$emit('conformedRouteSelected', JSON.stringify({ name: conformedRouteName, params: { stream: '' } }));
          }
          return 'Foyer';
        case 'Foyer Cards':
          return 'FoyerCategory';
        case 'Rede Social':
          return 'Timeline';
        case 'Cabine de Fotos':
          return 'PhotoBooth';
        case 'iFrame':
          return 'Iframe';
        case 'HTML':
          return 'Iframe';
        case 'VOD':
          return 'VideoGallery';
        case 'Game':
          return 'SlotMachine';
        case 'url':
          return 'url';
        default:
          return routeName;
      }
    },
    displayRoute(routeName) {
      switch (routeName) {
        case 'Schedule':
          return 'Agenda';
        case 'Trails':
          return 'Trilhas';
        case 'UserProfile':
          return 'Perfil';
        case 'Foyer2D':
          return 'Foyer 2D';
        case 'Foyer':
          return 'Foyer 360';
        case 'FoyerCategory':
          return 'Foyer Cards';
        case 'Timeline':
          return 'Rede Social';
        case 'PhotoBooth':
          return 'Cabine de Fotos';
        case 'IFrame':
          return 'iFrame';
        case 'Iframe':
          return 'iFrame';
        case 'VideoGallery':
          return 'VOD';
        case 'SlotMachine':
          return 'Game';
        case 'url':
          return 'url';
        default:
          return routeName;
      }
    },
    parseStream() {
      this.route.params.stream = this.routeStream;
      // Emit explorerPanel in params for Explorer
      if (this.route.name === 'Explorer') {
        this.$emit(
          'routeSelected',
          JSON.stringify({
            name: this.conformedRoute,
            params: { stream: this.routeStream, panel: this.explorerPanel },
          })
        );
        this.$emit(
          'conformedRouteSelected',
          JSON.stringify({
            name: this.conformedRoute,
            params: { stream: this.routeStream, panel: this.explorerPanel },
          })
        );
      } else if (this.route.name === 'Agenda') {
        this.$emit('routeSelected', JSON.stringify({ name: 'Schedule', params: { date_start: this.agendaStartDate } }));
        this.$emit('conformedRouteSelected', JSON.stringify({ name: 'Schedule', params: { date_start: this.agendaStartDate } }));
      } else {
        this.$emit('routeSelected', JSON.stringify({ name: this.conformedRoute, params: { stream: this.routeStream } }));
        this.$emit('conformedRouteSelected', JSON.stringify({ name: this.conformedRoute, params: { stream: this.routeStream } }));
      }
      if (this.routeStream) this.$emit('streamPicked');
    },
    standChanged() {
      this.$emit(
        'conformedRouteSelected',
        JSON.stringify({
          name: this.conformedRoute,
          params: {
            stream: this.routeStream,
            standFromLink: this.standFromActivity,
          },
        })
      );
      this.$nextTick(() => this.$emit('streamPicked'));
    },
    loadAgenda() {
      api
        .get(`event/${this.$store.state.eventId}/agenda`)
        .then((response) => {
          if (!response.data.length) return;
          // console.log('loadAgenda', response);
          this.agendaDates = response.data.map((item) => {
            return item.date_start;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  beforeMount() {
    this.loadRoutes();
    this.loadAgenda();
  },
};
</script>

<style lang="scss" scoped>
.dark-slicky-select {
  background-color: transparent;
  color: #000000;
  border: 1px solid #333;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  min-width: 0; /* Allow flex items to shrink below their content size */
  max-width: 100%; /* Prevent overflow */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ap-option-item {
  padding: 8px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
